'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './sub-list.routes';

export class SubListComponent {
  constructor(User, DTOptionsBuilder, $state, Config, Auth, $uibModal, IntegrationService, MailsService, dialogs, $http) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Sub List");
    this.Auth = Auth;
    this.$uibModal = $uibModal;
    this.MailsService = MailsService;
    this.dialogs = dialogs;

    this.masterUrl = Config.getPlatformConfig().getMasterUrlWeb();

    this.checked = {};

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lfrtip')
      .withOption('hasBootstrap', true)
      .withOption('responsive', true)
      .withOption('pageLength', 50);


    this.nothingSelected = _ => {
      let keys = Object.keys(this.checked);

      if (keys.length == 0)
        return true;

      let o = keys.filter(key => this.checked[key]);

      return o.length == 0;
    };

    this.groups = Config.getModuleConfig(Config.Modules.General).getGroups();
    this.groupKey = Config.getPlatformConfig().getGroupKey();

    let onComplete = _ => {
      this.showData = true;
    };

    this.done = 0;
    this.maxDone = this.groups.length + 1;

    this.data = [];

    this.groups.forEach(group => {

      $http({
        method: 'GET',
        url: group.url + '/api/users'
      }).then((response) => {

        let data = response.data
          .filter(user => user.active && user.role.includes("member") && user.willSubFor && user.willSubFor.includes(this.groupKey))
          .map(user => {

            user.groupName = group.name;
            user.apiPath = group.url;

            let workPhone = user.profile.phone.find(phone => phone.type == 'Work');
            let publicCellPhone = user.profile.phone.find(phone => phone.type == 'Cell' && !phone.private);

            if (workPhone)
              user.workPhone = workPhone.number;

            if (publicCellPhone)
              user.cellPhone = publicCellPhone.number;

            return user;
          });

        this.data = this.data.concat(data);

        this.done++;

        if (this.done == this.maxDone)
          onComplete();
      }, (response) => {
        // called asynchronously if an error occurs
        // or server returns response with an error status.
        this.done++;

        if (this.done == this.maxDone)
          onComplete();
      });
    });

    /* Get External Sub List from Master */

    $http({
      method: 'GET',
      url: this.masterUrl + '/api/subs'
    }).then((response) => {

      let data = response.data
        .filter(sub => sub.meta.active && sub.willSubFor && sub.willSubFor.includes(this.groupKey))
        .map(sub => {

          sub.isExtern = true;
          sub.groupName = "Extern";

          return sub;
        });

      this.data = this.data.concat(data);

      this.done++;

      if (this.done == this.maxDone)
        onComplete();
    }, (response) => {
      // called asynchronously if an error occurs
      // or server returns response with an error status.
      this.done++;

      if (this.done == this.maxDone)
        onComplete();
    });

    /*
    IntegrationService.querySubList(data => {
      //let data = users.filter(user => !user.role.includes("superadmin") && !user.role.includes("system"));

      this.data = data.map(user => {

        let workPhone = user.profile.phone.find(phone => phone.type == 'Work');
        let publicCellPhone = user.profile.phone.find(phone => phone.type == 'Cell' && !phone.private);

        if (workPhone)
          user.workPhone = workPhone.number;

        if (publicCellPhone)
          user.cellPhone = publicCellPhone.number;

        return user;
      });
    });
    */

  }

  formatPhone(number) {
    if (!number)
      return "-";

    try {
      var f_val = number.replace(/[^0-9]/g, "");
      return f_val.slice(0,3)+"-"+f_val.slice(3,6)+"-"+f_val.slice(6);
    } catch(err) {
      return "-";
    }

  }

  copyAll() {
    let emails = this.data.map(member => member.email);
    prompt("All Emails", [...new Set(emails)].join('; '));
  }

  copySelected() {
    let emails = this.data
      .filter(member => this.checked[member._id])
      .map(member => member.email);

    prompt("Selected Emails", [...new Set(emails)].join('; '));
  }

  mailAll() {
    let emails = this.data.map(member => member.email);
    this.doSendMail([...new Set(emails)]);
  }

  mailSelected() {
    let emails = this.data
      .filter(member => this.checked[member._id])
      .map(member => member.email);
    this.doSendMail([...new Set(emails)]);
  }

  doSendMail(emails) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      size: 'md',
      animation: true,
      component: 'messageForm',
      resolve: {
        config: function() {
          return {};
        }
      }
    });

    modalInstance.result.then(message => {

      that.MailsService.sendSubRequest({id: that.Auth.getCurrentUserSync()._id}, {emails, message}, () => {
        that.dialogs.notify("Your message has been sent","Your message has been sent.");
      });

    }, _ => {
      // Cancel
    });
  }

}

export default angular.module('conduuApp.subList', [uiRouter])
  .config(routes)
  .component('subList', {
    template: require('./sub-list.html'),
    controller: SubListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/sub/sub-list.component.js